import { render, staticRenderFns } from "./plans.vue?vue&type=template&id=adb1db6a&scoped=true&"
import script from "./plans.vue?vue&type=script&lang=js&"
export * from "./plans.vue?vue&type=script&lang=js&"
import style0 from "./plans.vue?vue&type=style&index=0&id=adb1db6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb1db6a",
  null
  
)

export default component.exports